
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"48","height":"48","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M18.767 4.07A2 2 0 0120.245 6v13H26a2 2 0 011.73 3.003l-12.177 21A2 2 0 0111.823 42V29H6a2 2 0 01-1.728-3.007l12.245-21a2 2 0 012.25-.924zM9.48 25h4.342a2 2 0 012 2v7.564L22.528 23h-4.283a2 2 0 01-2-2v-7.6L9.48 25zM36 28.5a1.5 1.5 0 011.342.83l6 12a1.5 1.5 0 11-2.684 1.34l-1.085-2.17h-7.146l-1.085 2.17a1.5 1.5 0 11-2.684-1.34l6-12A1.5 1.5 0 0136 28.5zm-2.073 9h4.146L36 33.354 33.927 37.5z","fill":"#0ABEC3"}})])
          )
        }
      }
    